import {
    Component,
    computed,
    DestroyRef,
    effect,
    ElementRef,
    HostListener,
    inject,
    input,
    output,
    signal
} from '@angular/core';
import { FormsModule } from '@angular/forms';

import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

import {DepartmentService} from "../../../services";
import {DepartmentGetAllDTO} from "../../../modules/product-devolopment/interface/department.entity";

@Component({
    selector: 'app-search-department',
    imports: [FormsModule],
    template: `
        <div class="searchable-dropdown">
            <select
                    id="department"
                    class="input-M peer"
                    [(ngModel)]="selectedDepartmentId"
                    (ngModelChange)="onDepartmentChange($event)"
                    [disabled]="disabled()">
                <option hidden value="-1">Select Department</option>
                @for (dep of departments(); track dep.departmentId) {
                    <option [value]="dep.departmentId">{{ dep.departmentCode }}</option>
                }
            </select>
            <label for="department" class="floating-c-lbl">Department @if (required()) {
                <span class="text-red-700">*</span>
            } </label>
        </div>
    `,
    styleUrls: ['./search-department.component.scss'],
    standalone: true
})
export class SearchDepartmentComponent {
    private departmentService = inject(DepartmentService);
    private elementRef = inject(ElementRef);
    private destroyRef = inject(DestroyRef);

    selectedDepartment = output<number>();
    disabled = input<boolean>(false);
    departmentId = input<number | null>(null);
    required = input<boolean>(true);

    selectedDepartmentId = signal<number>(-1);
    departments = computed(() =>
        this.departmentService.all()?.filter((dep: DepartmentGetAllDTO) => dep.useForGPD === 1) || []
    );
    isManuallySet = signal<boolean>(false); // Track manual selection

    constructor() {
        // effect(() => {
        //     const newDepartmentId = this.departmentId();
        //     const validDepartmentId = typeof newDepartmentId === 'number' && newDepartmentId > 0 ? newDepartmentId : -1;
        //
        //     if (validDepartmentId !== this.selectedDepartmentId() && !this.isManuallySet()) {
        //         this.selectedDepartmentId.set(validDepartmentId);
        //         this.selectedDepartment.emit(validDepartmentId);
        //     }
        // });
        //
        // effect(() => {
        //     this.departmentService.find({
        //         use_for_gpd: '1',
        //         department_status: '',
        //         page_number: '1',
        //         items_per_page: '100'
        //     }, true)
        //         .pipe(takeUntilDestroyed(this.destroyRef))
        //         .subscribe({
        //             next: () => {
        //                 const currentId = this.selectedDepartmentId();
        //                 if (currentId !== -1 && !this.departments().some(dep => dep.departmentId === currentId) && !this.isManuallySet()) {
        //                     this.clearSelection();
        //                     console.log(`Cleared selection because ${currentId} not in list and not manually set`);
        //                 }
        //             },
        //             error: (error) => {
        //                 console.error('Error fetching departments:', error);
        //             }
        //         });
        // });
    }

    onDepartmentChange(id: number) {
        this.selectedDepartmentId.set(id);
        this.isManuallySet.set(true); // Mark as manually set
        this.selectedDepartment.emit(id);
        console.log(`Manually selected department: ${id}`);
        if (id === -1) {
            this.clearSelection();
        }
    }

    @HostListener('document:click', ['$event'])
    clickOutsideDropdown(event: Event) {
        if (!this.elementRef.nativeElement.contains(event.target) && !this.disabled()) {
            if (this.departments().length === 0) {
                this.clearSelection();
                console.log('Cleared selection due to click outside with no departments');
            }
        }
    }

    clearSelection() {
        this.selectedDepartmentId.set(-1);
        this.isManuallySet.set(false); // Reset manual flag
        this.selectedDepartment.emit(-1);
    }
}